import { axiosInstancePrivateServicesFluxiUrl } from "@/services/instance";
import type { UserDetailUpsertPayload } from "../types/userDetail.types";

export const userDetailService = {
  async upsert(payload: UserDetailUpsertPayload): Promise<any> {
    const response = await axiosInstancePrivateServicesFluxiUrl.put(
      `/api/ms/ecommerce-service/user/detail`,
      payload
    );
    return response.data;
  },
};


